import getMobileOperatingSystem from '@utils/userAgent/getMobileOS';
import axios from 'axios';
import { OS } from '@utils/constants';
import { error as logError } from '@logger';

const generateAndroidUrl = (cartId, shopId, userHash) => {
  const baseUrl = 'market://details?id=com.pedidosya&referrer=';
  const referrer = `deeplink%3Dpedidosya%3A%2F%2Fcheckout%2Fstart%3Forigin%3Dcart%26cart_guid%3D${encodeURIComponent(
    cartId,
  )}%26partner_id%3D${encodeURIComponent(shopId)}%26hash%3D${encodeURIComponent(
    userHash,
  )}`;

  return baseUrl + encodeURIComponent(referrer);
};

const STORE_LINKS = {
  iOS: 'https://itunes.apple.com/uy/app/pedidosya/id490099807',
};

const goToAppLink = async ({ cartId, shopId, searchedLocation }) => {
  try {
    const os = getMobileOperatingSystem();
    const { data: userHash } = await axios.get('/user-hash');

    // iOS flow
    if (os === OS.IOS) {
      const iOSLink = `pedidosya://www.pedidosya.com/checkout/start?origin=cart&cart_guid=${cartId}&partner_id=${shopId}&hash=${userHash}&lat=${searchedLocation?.latitude}&long=${searchedLocation?.longitude}`;

      // App not installed
      setTimeout(async () => {
        await navigator.clipboard.writeText(iOSLink);
        window.location.href = STORE_LINKS.iOS;
      }, 200);

      // App installed
      window.location.href = iOSLink;
    }

    // Android flow
    if (os === OS.ANDROID) {
      // App not installed
      setTimeout(() => {
        const url = generateAndroidUrl(cartId, shopId, userHash);
        window.location.href = url;
      }, 200);

      // App installed
      window.location.href = `pedidosya://checkout/start?origin=cart&cart_guid=${cartId}&partner_id=${shopId}`;
    }
  } catch (error) {
    logError('[WEB_TO_NATIVE_CHECKOUT]', { error });
  }
};

export default goToAppLink;
